export const EmailRegex = /^\w+([+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/;
export const ExpiryDateRegex = /^(0[1-9]|1[0-2])\\\/[0-9]{2}$/;
export const cvvRegex = /^([0-9]{3,4})$/;
export const americanExpress_CC_Regex = "^3[47]";
export const discover_CC_Regex = /^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)/;
export const diners_CC_Regex= /^36/;
export const dinersCarte_CC_Regex =/^30[0-5]/;
export const jcb_cc_Regex = /^35(2[89]|[3-8][0-9])/;
export const visaElectron_CC_Regex = /^(4026|417500|4508|4844|491(3|7))/;
export const visa_CC_Regex = /^4/;
export const masterCard_CC_Regex = /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/;
export const defaultFitness = "Fitness";
export const USPhoneRegex = /^\+[1-9]{1,5} {1}[(]{1,1}[0-9]{3,3}[)]{1,1} {1}[0-9]{3,3} {1}[-]{1,1} {1}[0-9]{4,4}$/;
export const PhoneRegex = /^\+[1-9]{1,5} {1}[0-9]{10,10}$/;
export const AUPhoneRegex = /^\+[1-9]{1,5} {1}[0-9]{9,9}$/;
export const cardHolderName = /^[a-zA-Z ]+$/;
export const characterRegex =  /^[a-zA-Z ]*$/;
export const onBoardingLanguageLocalStorageKey = "OnBoardingLanguageKey";
export const onBoardingIntegrationTypeLocalStorageKey = "OnBoardingIntegrationKey";
export const onBoardingCountryLocalStorageKey = "OnBoardingCountryKey";
export const creditCardRegex = /^(?:4[0-9]{12}(?:[0-9]{3})?|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/;
export const onBoardingLookpResultLocalStorageKey = "OnBoardingLookupResultKey";
export const numberwithMaxLength10 = /^\d{10}$/;
export const websiteRegex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
export const onBoardingBusinessNameLocalStorageKey = "OnBoardingBusinessNameKey";
export const userDetailsLocalStorageKey = "userDetailKey";
export const studioIdRegex = /^-?[0-9]{1,10}$/
export const mobileViewWidth = 767;
export const ipadViewWidth = 1024;

// Global exceptions handler messages
export const unknownError = "Unknown error, please try again. If error persists, please send email to support.";
export const serverDownError = "Server is down, please send email to support.";
export const unauthorizedError = "Unauthorized";
export const notFoundError = "Not Found";
export const failedToProcessError = "Uh oh! We couldn’t process your request. Please try again."
export const forbiddenError = "Session Expired.";
export const snackBarOpen = "snack-bar-open";
export const snackBarClose = "snack-bar-close";